<template>
  <div class="bg-white rounded-2xl p-7 border border-[#1c4848]/10 shadow-sm" :class="[wrapperClass]">
    <div class="mb-6">
      <h3 class="text-[20px] font-medium tracking-tight text-[#1c4848]">{{ title }}</h3>
      <p class="text-[15px] text-[#1c4848]/55 mt-1">
        {{ subtitle }}
      </p>
    </div>

    <p v-if="!rows.length" class="text-base text-[#1c4848]/40 py-8 text-center">
      No paywall views recorded yet.
    </p>

    <div v-else class="space-y-4">
      <div v-for="row in rows" :key="row.source" class="flex items-center gap-4">
        <div class="flex-1 min-w-0">
          <div class="flex items-baseline justify-between gap-2">
            <span class="text-lg font-medium text-[#1c4848] truncate">{{ prettify(row.source) }}</span>
            <span class="text-[13px] font-semibold text-[#1c4848]/45 shrink-0">
              {{ formatNumber(row.views) }} views
            </span>
          </div>
          <div class="w-full h-3 rounded-full bg-[#1c4848]/5 overflow-hidden mt-1.5">
            <div class="h-full rounded-full bg-[#ecd79f]" :style="{ width: `${Math.max(row.conversion_rate, 1)}%` }" />
          </div>
        </div>
        <span
          class="text-[13px] font-medium px-2 py-1 rounded-lg shrink-0"
          :class="row.conversion_rate > 0 ? 'text-emerald-600 bg-emerald-50' : 'text-[#1c4848]/40 bg-[#1c4848]/5'"
        >
          {{ row.conversion_rate }}%
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, default: 'Where the Paywall Is Seen' },
  subtitle: { type: String, default: 'Views and conversion by entry point' },
  rows: { type: Array, default: () => [] },
  wrapperClass: { type: String, default: '' },
});

function prettify(source) {
  if (!source || source === 'unknown') return 'Unknown source';
  return source.replace(/[_-]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

function formatNumber(value) {
  return new Intl.NumberFormat('en-US').format(value ?? 0);
}
</script>
